import PropTypes from "prop-types";
import clsx from "clsx";
import bannerData from "../../data/banner/banner-three.json";
import BannerThreeSingle from "../../components/banner/BannerThreeSingle.js";
import { HomepageFeaturedProduct } from "../../shared/commonUtils";
import React from "react";
import { CSS_VARIABLES } from "../../shared/cssVariable";
interface IBannerThree {
  bannerData: HomepageFeaturedProduct[];
  spaceBottomClass?: any;
}
const BannerThree: React.FC<IBannerThree> = (props: IBannerThree) => {
  const { spaceBottomClass, bannerData } = props;
  return (
    <div
      style={{ background: `var(${CSS_VARIABLES.productTabColor})` }}
      className={clsx("banner-area", spaceBottomClass, "pb-30", "pt-30")}
    >
      <div className="container">
        {bannerData && bannerData.length !== 1 && (
          <div className="row banner-bottom-gap">
            {bannerData &&
              bannerData?.map((single, key) => (
                <div className="col-lg-6 col-md-6" key={key}>
                  <BannerThreeSingle data={single} spaceBottomClass="mb-30 " />
                </div>
              ))}
          </div>
        )}
        {bannerData.length === 1 && (
          <div className="row- banner-bottom-gap">
            {bannerData?.map((single, key) => (
              <div className="col-lg-12 col-md-12" key={key}>
                <BannerThreeSingle
                  data={{
                    ...single,
                    image: single?.image[0].replace("width=600", "width=1200"),
                  }}
                  spaceBottomClass="mb-30 "
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

BannerThree.propTypes = {
  spaceBottomClass: PropTypes.string,
};

export default BannerThree;
